import { z } from "zod"

export enum CertificatesListView {
  SCOPE = "scope",
  TRANSACTION = "transaction",
  ALL = "all",
}

export const CertificatesListViewSchema = z.enum(CertificatesListView)
